import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress page — permanently redirect to the canonical post.
export const Route = createFileRoute("/laser-therapy-for-hair-loss")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/low-level-laser-therapy-for-hair-loss/", location.searchStr), statusCode: 301 });
  },
});
